/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';


// import ReactDOM from 'react-dom';
class Navbar extends React.Component {
    constructor(props) {
        super(props)
        this.state = { isOpen: false, nav: "navbar-menu", burger: "navbar-burger" }
        this.updateCssOnNavbarForMobile = this.updateCssOnNavbarForMobile.bind(this)
    }
    renderLoginButton() {
        if (!this.props.isLoggedIn) {
            return <Link className="button is-light" to="/login">
                <span class="icon is-small">
                    <i class="fas fa-sign-in-alt"></i>
                </span>
                <span>Log in</span>
            </Link>
        }
        else {
            return <button className="button is-light" onClick={this.props.logout}>
                <span class="icon is-small">
                    <i class="fas fa-sign-out-alt"></i>
                </span>
                <span>Log Out</span>
            </button>
        }
    }
    renderSignUpButton() {
        if (!this.props.isLoggedIn) {
            return <Link className="button is-primary" to="/signup"><strong>Sign up</strong></Link>
        }
        else {
            return <></>
        }
    }
    renderCreateNoteButton() {
        if (this.props.isLoggedIn) {
            return <Link className="button is-primary" to="/createnote">
                <span class="icon is-small">
                    <i class="fas fa-feather"></i>
                </span>
                <span><strong>Write Diary</strong></span>
            </Link>
        }
        else {
            return <></>
        }
    }
    updateCssOnNavbarForMobile() {
        if (this.state.isOpen) {
            this.setState({
                isOpen: false,
                nav: "navbar-menu",
                burger: "navbar-burger"
            })
        }
        else {
            this.setState({
                isOpen: true,
                nav: "navbar-menu is-active",
                burger: "navbar-burger is-active"
            })
        }

    }
    render() {
        return (
            <nav className="navbar  has-shadow" role="navigation" aria-label="main navigation">
                <div className="navbar-brand">
                    <Link to="/" className="navbar-item" >
                        <img src="/case-study.png" alt="logo" className="ml-2" />
                        <p className="ml-2 is-size-5">The Diary App</p>
                    </Link>
                    <a href role="button" className={this.state.burger} aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" onClick={() => { this.updateCssOnNavbarForMobile() }}>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </a>
                </div>

                <div id="navbarBasicExample" className={this.state.nav}>
                    <div className="navbar-end">
                        <div className="navbar-item">
                            <div className="buttons">
                                {this.renderCreateNoteButton()}
                                {this.renderSignUpButton()}
                                {this.renderLoginButton()}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        )
    }
}

export default Navbar